import React from 'react'

const Explanation = () => {
  return (
    <div className='fullscreen'>
        <h2>Loading...</h2>
        <img src="./image/process_exp.png" alt="Process Explanation" />
    </div>
  )
}

export default Explanation